import React from 'react';
import {debounceTime, map} from 'rxjs/operators';

import styles from 'iss/styles/Loading.styl';
import {getOnGoingRequests, requestCount} from 'iss/utils/ajax';
import subscribeTo from 'iss/utils/subscriptionUtils';

/** Emits true if there are ajax requests going on in the background for more than 100 milliseconds */
const hasRequestObservable = requestCount.pipe(
  map((count) => count > 0),
  debounceTime(100)
);

/** Displays an all screen loading indicator if an ajax request is
 * loading in the background and config parameter showLoadingScreen: false
 * is not used in the request
 **/
export const RequestLoadingIndicator = subscribeTo(hasRequestObservable, "hasRequest", function render({hasRequest,id}) {
  const requestClasses = getOnGoingRequests().map(req => req.replace(/[^a-zA-Z0-9]+/g, '-')).join(" ");
  return hasRequest ? <div id={id} className={styles.loading+" "+requestClasses} /> : null;
});

/** Regular loading indicator used for some component loading requests */
export function LoadingIndicator({isLoading}) {
  return isLoading ? <div id='loading' className={"loading "+styles.loadingIndicator} /> : null;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/LoadingIndicator.jsx